import { createGlobalStyle } from "styled-components";

const ChatGlobalStyle = createGlobalStyle`
  @media (max-width: 960px) {
    body {
      overflow: hidden;
      height: 100vh;
    }
  }

  .chat-wrap {
    min-height: 100vh;
    color: #e5e7eb;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  @media (max-width: 960px) {
    .chat-wrap {
      height: 100vh;
      overflow: hidden;
    }
  }

  .max {
    max-width: 1240px;
    margin: 0 auto;
    padding: 20px;
  }

  @media (max-width: 960px) {
    .max {
      padding: 0;
      height: 100vh;
      max-width: 100%;
    }
  }

  .card {
    background: radial-gradient(100% 160% at 0% 0%, rgba(56,189,248,0.16), rgba(15,23,42,0.98));
    border: 1px solid #1f2937;
    border-radius: 16px;
    box-shadow: 0 18px 40px rgba(0,0,0,0.35);
  }

  @media (max-width: 960px) {
    .card {
      border-radius: 0;
      box-shadow: none;
      height: 100vh;
      display: flex;
      flex-direction: column;
    }
  }

  .tabs {
    display: flex;
    gap: 8px;
    padding: 8px;
  }

  .tab {
    flex: 1;
    text-align: center;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #1f2937;
    background: #020617;
    cursor: pointer;
    font-weight: 500;
    font-size: 12px;
    color: #e5e7eb;
    transition: all 0.16s ease;
  }

  .tab.active {
    background: linear-gradient(90deg, #00f7d2, #5ce9ff);
    color: #001018;
    border-color: #0f172a;
    font-weight: 700;
  }

  .filter-tabs {
    display: flex;
    gap: 8px;
    padding: 12px 14px 8px;
  }

  .filter-tab {
    flex: 1;
    text-align: center;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #1f2937;
    background: rgba(15, 23, 42, 0.6);
    cursor: pointer;
    font-weight: 500;
    font-size: 12px;
    color: #e5e7eb;
    transition: all 0.16s ease;
  }

  .filter-tab.active {
    background: rgba(0, 247, 210, 0.2);
    color: #00f7d2;
    border-color: rgba(0, 247, 210, 0.4);
    font-weight: 600;
  }

  .grid {
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 14px;
  }

  @media (max-width: 960px) {
    .grid {
      grid-template-columns: 1fr;
      gap: 0;
      height: 100vh;
    }

    .sidebar.show-chat {
      display: none;
    }

    .pane.show-list {
      display: none;
    }
  }

  .sidebar {
    display: flex;
    flex-direction: column;
    height: 76vh;
  }

  @media (max-width: 960px) {
    .sidebar {
      height: 100vh;
    }
  }

  .search {
    padding: 0 14px 12px;
  }

  .search input {
    width: 100%;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #1f2937;
    background: rgba(15, 23, 42, 0.6);
    color: #e5e7eb;
    outline: none;
    font-size: 13px;
  }

  .search input::placeholder {
    color: #94a3b8;
  }

  .search input:focus {
    border-color: #00f7d2;
    background: rgba(15, 23, 42, 0.8);
  }

  .threads {
    overflow: auto;
    padding: 6px 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
  }

  .thread {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid transparent;
    background: rgba(15, 23, 42, 0.4);
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .thread:hover {
    background: rgba(15, 23, 42, 0.6);
  }

  .thread.active {
    border: 1px solid rgba(0, 247, 210, 0.5);
    background: rgba(15, 23, 42, 0.6);
  }

  .avatar {
    height: 40px;
    width: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #5ce9ff, #00f7d2);
    color: #001018;
    font-weight: 900;
    display: grid;
    place-items: center;
    position: relative;
    font-size: 14px;
    flex-shrink: 0;
    overflow: hidden;
  }

  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }

  .dot {
    position: absolute;
    right: -3px;
    bottom: -3px;
    height: 10px;
    width: 10px;
    border-radius: 999px;
    background: #22c55e;
    border: 2px solid rgba(15,23,42,0.98);
  }

  .pane {
    display: flex;
    flex-direction: column;
    height: 76vh;
  }

  @media (max-width: 960px) {
    .pane {
      height: 80vh;
    }
  }

  .pane-head {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #1f2937;
    background: rgba(15, 23, 42, 0.98);
    min-height: 60px;
    flex-shrink: 0;
  }

  .back-button {
    display: none;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background: transparent;
    color: #e5e7eb;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 20px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .back-button:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 960px) {
    .back-button {
      display: flex;
    }
  }

  .pane-head .title {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
  }

  .pane-head .avatar {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    border: 2px solid rgba(92, 233, 255, 0.3);
    background: linear-gradient(135deg, #5ce9ff, #00f7d2);
    color: #001018;
    font-weight: 900;
    display: grid;
    place-items: center;
    position: relative;
    font-size: 14px;
    flex-shrink: 0;
    overflow: hidden;
  }

  .pane-head .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  .pane-head .user-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;
  }

  .pane-head .user-name {
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }

  .pane-head .user-status {
    font-size: 13px;
    color: #94a3b8;
    text-transform: uppercase;
    line-height: 1.2;
    margin-top: 2px;
  }

  .pane-body {
    flex: 1;
    overflow-y: auto;
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: linear-gradient(180deg, rgba(0,0,0,.15), rgba(2,6,23,0.3));
    min-height: 0;
  }

  .pane-input-wrapper {
    flex-shrink: 0;
    border-top: 1px solid #1f2937;
    padding: 10px;
    background: rgba(15, 23, 42, 0.98);
  }

  .bubble {
    max-width: 70%;
    padding: 10px 12px;
    border-radius: 14px;
    border: 1px solid #1f2937;
    line-height: 1.45;
    color: #e5e7eb;
  }

  .from-me {
    align-self: flex-end;
    background: rgba(0,247,210,.15);
    border-color: rgba(0,247,210,.25);
  }

  .from-them {
    align-self: flex-start;
    background: rgba(15,23,42,.6);
    border-color: #1f2937;
  }

  .meta {
    font-size: 11px;
    color: #94a3b8;
    margin-top: 4px;
  }

  .files {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin-top: 6px;
  }

  .filechip {
    font-size: 12px;
    border: 1px dashed #1f2937;
    padding: 4px 8px;
    border-radius: 8px;
    color: #e5e7eb;
  }

  .empty {
    height: 100%;
    display: grid;
    place-items: center;
    color: #94a3b8;
  }
`;

export default ChatGlobalStyle;

